module.exports = __webpack_public_path__ + "img/leaf-icon.474fdfd9.svg";